import { useContext } from 'react';
import styled from '@emotion/styled';
import { AddToDashboardButton } from './Chat.Chart.AddToDashboard';
import { ChartFilterPane } from './Chat.Chart.Settings';
import { ChartDataTable } from './Chat.ChartDataTable';
import { ChartViewButton, TableViewButton } from './Chat.Chat.ViewToggle';
import { ChartInfoContext, ChartViewContext } from './context';

interface ChartViewContainerProps {
  renderChart: () => React.ReactNode;
  chartType: string;
}

export function ChartViewContainer({ renderChart, chartType }: ChartViewContainerProps) {
  const [viewMode, setViewMode] = useContext(ChartViewContext);
  const [chart] = useContext(ChartInfoContext);

  return (
    <>
      <ChartHeaderContainer>
        <Title>{chart.chart.chart.title}</Title>
        <ButtonBar>
          <ViewToggleGroup>
            <ChartViewButton
              onClick={() => setViewMode('chart')}
              viewMode="chart"
              isActive={viewMode === 'chart'} />

            <TableViewButton
              onClick={() => setViewMode('table')}
              viewMode="table"
              isActive={viewMode === 'table'} />
          </ViewToggleGroup>

          <ActionButtonGroup>
            <AddToDashboardButton />
            <ChartFilterPane />
          </ActionButtonGroup>
        </ButtonBar>
      </ChartHeaderContainer>

      {viewMode === 'chart' ? (
        <NivoChartContainer>{renderChart()}</NivoChartContainer>
      ) : (
        <ChartDataTable
          data={chart.chart.chart.data}
          chartData={chart}
          chartType={chartType} />
      )}
    </>
  );
}

const ChartHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;
`;

const Title = styled.div(({ theme }) => ({
  fontFamily: theme.fonts.semiBold,
  textAlign: 'center',
}));

const ButtonBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ViewToggleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const ActionButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const NivoChartContainer = styled.div`
  height: 320px;
  width: 100%;
`;